import { request, RequestError, RequestErrorType } from '@tencent/vft-common/request';
import env from '@tencent/vft-common/env';
import util from '@tencent/vft-common/util';

let bizId = util.getUrlParam('bizId') || ''; // 业务标识
const type = util.getUrlParam('type') || ''; // 协议类型
const version = util.getUrlParam('version') || ''; // 查看指定版本号

// http://wuji.oa.com/p/edit?appid=vip&schemaid=service_agreement_new
export async function getTerm() {
  const plat = env.isIos && env.isApp ? 'ios' : 'android';
  if (type.match(/^(svip|nba)$/)) { // 兼容现网传参逻辑
    bizId = type;
  }
  const filter = `bizId="${bizId || 'hvip'}"&plat="${plat}"`;
  return request('//node.video.qq.com/x/api/wuji_cache/object?appid=vip&schemaid=service_agreement_new&schemakey=d9534c75a3bb467b8a4ebf924a13c2c0', {
    filter,
    sort: '_ctime',
    order: 'desc',
  }, {
    dataType: 'json',
  }).then((res) => {
    if (!res) {
      throw new RequestError(-2, '网络开了小差，请重试', res, RequestErrorType.SYSTEM_ERR);
    }
    if (!res.data || res.data.length === 0) {
      throw new RequestError(res.code, res.msg || '未知错误', res, RequestErrorType.LOGIC_ERR);
    }
    try {
      res.data = res.data.map(item => ({
        ...item,
        common: item.common && JSON.parse(item.common).content,
        serialpay: item.serialpay && JSON.parse(item.serialpay).content,
      }));
    } catch (e) {}
    // 查看无极配置的最新协议
    let activeTerm = res.data.find(item => (item.isActive));
    let histroyTerm = filterHistoryTermByWujiConfig(res.data);
    // 查看指定版本号的协议
    if (version) {
      activeTerm = res.data.find(item => (item.version === version));
      histroyTerm = filterHistoryTermByVersion(res.data);
    }
    return {
      activeTerm,
      histroyTerm,
    };
  });
}

// 查看默认的历史协议
function filterHistoryTermByWujiConfig(list) {
  const res = [];
  list.forEach((item) => {
    // 无极配置可见且是线上
    if (!item.isActive && item.isVisible) res.push(item);
  });
  return res;
}

// 指定版本时的历史协议
function filterHistoryTermByVersion(list) {
  const res = [];
  list.forEach((item) => {
    // 无极配置可见且不等于当前版本号
    if (item.isVisible && (item.version !== version)) res.push(item);
  });
  return res;
}
